var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"questionnaire__content"},[_c('transition',{attrs:{"name":_vm.transitionName}},[_c(_vm.activeQuestion,_vm._g({tag:"Question",attrs:{"module":_vm.module,"question":_vm.activeQuestion}},_vm.$listeners))],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }